import React, { Component } from 'react';
import { Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import { Redirect } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomModal from "../../components/Modal/CustomModal";
import { CustomCard } from "../../components/Card/CustomCard";
import HeaderHome from '../HeaderHome';

import logo from "../../assets/img/logo.png";
import { CheckToken, ChangePassW } from '../../funciones/ForgotFunction'

let statusUser = 0;
let statusToken = 1;
class RestartPass extends Component {
    state = {
        usuario: {
            icon: "fa fa-spinner fa-spin",
            text: "Comprobando,",
            textTipo: "text-muted"
        },
        usuName: {
            clase: "custom-alert-info",
            icon: "fa fa-spinner fa-spin",
            text: "Espera por favor",
            textTipo: "text-danger"
        },
        pass1:{
            text: "",
            status: ""
        },
        pass2:{
            text: "",
            status: ""
        },
        button: {
            Icon:"fa fa-key",
            Title:"Cambiar Contraseña"
        },
        boton1Modal: {
            Icon:"fa fa-check",
            Title:"Si"
        },
        boton2Modal: {
            Icon:"fa fa-check",
            Title:"Aceptar"
        },
        openW: false,
        openWOk: false,
        controlT: false,
    }

    constructor (props) {
        super (props);
        let Content = this.getGET();

        CheckToken(Content, (resp) => {
            if (resp.status === "error") {
                this.setState({
                    usuName:{
                        clase: "custom-alert-danger",
                        icon: "",
                        text: "EL ENLACE INGRESADO ES INVÁLIDO",
                        textTipo:"text-danger"
                    },
                    usuario: {
                        icon: "fa fa-exclamation-triangle",
                        text: "No Disponible",
                        textTipo: "text-muted"
                    },
                    openW: false,
                })
            }else{
                let tipo = "";
                statusUser = 1;
                switch (resp.user_type) {
                    case "DIR":
                        tipo = 'DIRECTIVO';
                        break;
                    case "PROF":
                        tipo = 'PROFESOR';
                        break;
                    case "EST":
                        tipo = 'ESTUDIANTE';
                        break;
                    default:
                        tipo = 'TOKEN INVÁLIDO';
                        break;
                }

                this.setState({
                    usuName:{
                        clase: "custom-alert-info",
                        icon: "",
                        text: resp.user_name,
                        textTipo:"text-danger"
                    },
                    usuario: {
                        icon: "fa fa-user",
                        text: tipo,
                        textTipo: "text-muted"
                    },
                    openW: false,
                })
            }
        });
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:event.target.value,
                status: ""
            },
            openW: false
        });
    };

    enterTab = (next) => (e) => {if (e.which === 13) document.getElementById(next).focus();}

    getGET = () => {
        let loc = document.location.href;
        if(loc.indexOf('?') > 0){
            let getString = loc.split('?')[1];
            let GET = getString.split('&');
            let get = {};
            for(let i = 0, l = GET.length; i < l; i++){
                let tmp = GET[i].split('=');
                get[tmp[0]] = unescape(decodeURI(tmp[1]));
            }
            return get;
        }
    }

    titulo = () => (
        <Row>
            <Col md={3}>
                <img src={logo} alt="User" className="img img-responsive"
                        style={{height:"auto", width:120}}/>
            </Col>
            <Col md={9} align="right">
                <span>Restaura tu Contraseña</span>
                <div className="text-muted" style={{fontSize:12, marginTop:-10}}>Completa todos los campos para continuar</div>
            </Col>
        </Row>
    )

    changePass = () => (e) => {
        const { pass1, pass2 } = this.state;

        if (pass2.text !== pass1.text) {
            toast.error("Las contraseñas no coinciden",{});
            return null;
        }

        if (pass2.text === "") {
            toast.error("Debes ingresar una contraseña",{});
            return null;
        }

        this.setState({ 
            boton1Modal: {
                Icon:"fa fa-check",
                Title:"Si"
            },
            openW:true
        })
    }

    funcion1 = () => {
        this.setState({
            boton1Modal: {
                Icon:"fa fa-spinner fa-spin",
                Title:"Espera por favor"
            },
        }, () => {
            let Content = this.getGET();
            let { pass2 } = this.state;
            ChangePassW(Content, pass2, (resp) => {
                if (resp.status === "ok") {
                    this.setState({ 
                        boton1Modal: {
                            Icon:"fa fa-check",
                            Title:"Si"
                        },
                        openW:false,
                        openWOk: true
                    })
                }else{
                    toast.error("Ocurrió un error durante la actualización de tu password",{});
                }
            });
        })
    }

    showModal = () => {
        const { boton1Modal, openW } = this.state;

        return (
            <CustomModal
                isopen =  {openW}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {<div>¿Deseas cambiar tu contraseña de <strong>Inicio de Sesión</strong>?</div>}
                boton1 = {<React.Fragment><i className={boton1Modal.Icon}></i> {boton1Modal.Title}</React.Fragment>}
                boton2 = "No"
                funcion1 = {this.funcion1}/>
        );
    }

    openModalOk = () => { this.setState({ openWOk:true }) }

    funcion2 = () => {
        statusToken = 0;
        this.setState({ controlT: !this.state.controlT })
    }

    modalOk = () => {
        const { boton2Modal, openWOk } = this.state;

        return (
            <CustomModal
                isopen =  {openWOk}
                titulo = {<div className="text-primary">Contraseña Modificada</div>}
                contenido = {<div>Has modificado tu contraseña con <strong>Éxito</strong> al presionar el botón aceptar serás redirigido a la ventana de <strong>Login</strong></div>}
                boton1 = {<React.Fragment><i className={boton2Modal.Icon}></i> {boton2Modal.Title}</React.Fragment>}
                boton2 = ""
                funcion1 = {this.funcion2}/>
        );
    }

    contenido = () => {
        let { usuario, usuName, pass1, pass2, button } = this.state;

        let help1 = (
            <Popover title="Contraseña" id="pass">
                Introduce una <strong>Contraseña segura</strong>
            </Popover>
        )

        let help2 = (
            <Popover title="Cambiar Contraseña" id="pass">
                <div className="custom-alert-danger">Enlace inválido</div>
                <div className="custom-mt-10" align="justify">
                    Para poder restaurar tu contraseña debes ingresar el enlace que se envió a tu dirección de correo electrónico.
                </div>
                <div className="custom-mt-10" align="justify">
                    Para eso ve a la ventana de <strong>Login</strong> y haz click en la opción <a>Olvidé mi contraseña</a>
                </div>
            </Popover>
        )

        let botones = () => {
            switch (statusUser) {
                case 0:
                    return(
                        <OverlayTrigger trigger="focus" placement="left" overlay={help2}>
                            <button className="btn btn-primary" id="changePass" style={{borderWidth:1}}><i className= {button.Icon} style={{fontSize:16}}></i> {button.Title}</button>
                        </OverlayTrigger>
                    )
                case 1:
                    return(
                        <button className="btn btn-primary" id="changePass" onClick={this.changePass()} style={{borderWidth:1}}><i className= {button.Icon} style={{fontSize:16}}></i> {button.Title}</button>
                    )
                default:
                    return(<div></div>)
            }
        }

        return (
            <React.Fragment>
                <Row>
                    <Col md={3} align="right">
                        Tipo de Usuario:
                    </Col>
                    <Col md={9}>
                        <div className={usuario.textTipo}><i className={usuario.icon}></i> {usuario.text}</div>
                    </Col>
                    <Col md={12} style={{marginTop:10, marginBottom:10}}>
                        <div style={{fontSize: 14, padding:5}} className={usuName.clase}><i className={usuName.icon}></i> {usuName.text}</div>
                    </Col>

                    <Col md={10} align="right" style={{marginTop:10}}>
                        <Col md={5} align="right">
                            Nueva Contraseña:
                        </Col>
                        <Col md={7} style={{paddingRight: 0,}}>
                            <div className={pass1.status}>
                                <input type="password" id="pass1" onChange={this.cambiaValor("pass1")} onKeyPress={this.enterTab("pass2")} placeholder="Ingresa una contraseña" className="form-control"/>
                            </div>
                        </Col>
                        <Col md={5} align="right" style={{marginTop:10}}>
                            Repite la Contraseña:
                        </Col>
                        <Col md={7} style={{marginTop:10, paddingRight: 0,}}>
                            <div className={pass2.status}>
                                <input type="password" id="pass2" onChange={this.cambiaValor("pass2")} onKeyPress={this.enterTab("changePass")} placeholder="Repite contraseña" className="form-control"/>
                            </div>
                        </Col>
                    </Col>

                    <Col md={2} align="center" style={{marginTop:30}}>
                        <OverlayTrigger trigger="focus" placement="right" overlay={help1}>
                            <button className="btn btn-warning" style={{borderWidth:1}}><i className="fa fa-question-circle-o"></i></button>
                        </OverlayTrigger>
                    </Col>

                    <Col md={12} align="right" className="custom-mt-20">
                        {botones()}
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                En esta sección podrás modificar tu contraseña de usuario en caso de que la hayas olvidado.
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Para comenzar ingresa la contraseña de tu elección en el primer cuadro de texto
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Luego repite la contraseña que colocaste en el campo anterior
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Por último presiona el botón <button className="btn btn-xs btn-primary" style={{borderWidth:1}}><i className="fa fa-key"></i> Cambiar Contraseña</button> de la parte inferior
            </Col>
            <Col md={12} className="custom-mt-10" align="justify" style={{fontSize:9}}>
                Te aparecerá un mensaje de confirmación que al aceptarlo permitirá cambiar tu contraseña. Luego serás redirigido a la ventana de <strong>Inicio de Sesión</strong>
            </Col>
        </Row>
    )

    render() {
        switch (statusToken) {
            case 0:
                return(<Redirect to="/login" />) 
            case 1:
                return (
                    <React.Fragment>
                        <HeaderHome/>
                        <div className="login-content" style={{position:"fixed"}}>
                            <div className="wrapper2">
                                <div className="wave one"></div>
                                <div className="wave dos"></div>
                                <div className="wave tres"></div>
                            </div>
                            <Row>
                                <Col md={1}></Col>
                                <Col md={10}>
                                    <Col md={8}>
                                        <div style={{borderRadius: "4px 4px",}}>
                                        <CustomCard
                                            title={this.titulo()}
                                            color="#a80012"
                                            content={this.contenido()}
                                        />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <CustomCard
                                            styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                            title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                            category={<span style={{color: "#fff"}}>Restaura tu Contraseña</span>}
                                            color="#a80012"
                                            content={this.ayuda()}
                                        />
                                    </Col>
                                </Col>
                                <Col md={1}></Col>
                            </Row>
                        </div>
                        <ToastContainer
                            position="bottom-right"
                            autoClose={3000}/>
                        {this.showModal()}
                        {this.modalOk()}
                    </React.Fragment>
                );
            default:
                return(<Redirect to="/login" />) 
        }
    }
}
 
export default RestartPass;


// WEBPACK FOOTER //
// ./src/site/Views/RestartPass.jsx